import React from 'react'
import { ProductCare } from '@sainsburys-tech/bolt'
import { isEmpty } from '@sainsburys-tech/boltui-utils'

import { useFeatureClassName } from '@/javascript/hooks/useFeatureClassName'
import ProductCareWrapperComponent from '../ProductCareWrapper/ProductCareWrapper'

const ProductCareComponent = props => {
  const { className } = useFeatureClassName()
  const analytics = {
    pageName: 'ar:pdp:productcarelightbox:',
    clickOrigin: 'ar:pdp:monthlyproductcare',
    monthlyPageName: 'ar:pdp:monthlyproductcarelightbox',
    monthlyClickOrigin: 'ar:pdp:monthlyproductcare',
    shouldTrackTermsAndConditions: true,
    shouldTrackAddToTrolley: true,
    shouldTrackCloseModal: true
  }

  const { warrantyProductDetails: { attributes: { synapticaId } = {} } = {}, warranties = [] } = props

  const termsCare = warranties.filter(care => !care.type.startsWith('monthly_care'))

  const monthlyCare = (warranties.length > 0 && warranties.find(attr => attr.type.startsWith('monthly_care'))) || {}

  const jewellery = warranties.filter(care => care.type.includes('jewellery'))

  return (
    <div className={`${className} productCare`}>
      <ProductCare {...props.host} analytics={analytics}>
        {!isEmpty(monthlyCare) && <ProductCareWrapperComponent monthlyCare={monthlyCare} />}
        {isEmpty(jewellery) &&
          termsCare
            .filter(care => care.title)
            .map(care => (
              <ProductCare.ProductCareItem
                key='term-care'
                data-test='term-care'
                warrantyPartNumber={care.sku}
                warrantyName={care.title}
                warrantyPrice={care.price}
                ipidLink={care.links ? care.links.ipid : `https://documents.4rgos.it/v1/static/${synapticaId}_IPID`} // TODO remove when we stub or when product-care dev is fix
                leafletLink={
                  care.links ? care.links.leaflet : `https://documents.4rgos.it/v1/static/${synapticaId}_leaflet`
                }
                careType={care.type}
                warrantyItem={props.warrantyItem}
              />
            ))}
      </ProductCare>
    </div>
  )
}

export default ProductCareComponent
